$(document).ready(function() {
    $(".customText-save").click(function(e) {
        e.preventDefault();
        save($(this));
    });
    $(".customText-load").click(function(e) {
        e.preventDefault();
        load($(this));
    });


    function save($button) {
        var name = $button.data('name');
        var $textarea = $button.parent().parent().find("textarea");
        var text = $textarea.val();
        var confirm = $button.data('confirm');
        var confirmButton = $button.data('confirm-button');
        var $spinner = $button.find(".acf-spinner");
        var userId = $button.data('user');
        $spinner.addClass('is-active');


        $.ajax({
            type: "POST",
            url: "/wp-json/mxm_angebote/customtext/save",
            data: {
                'text': text,
                'type': name,
                'user': userId
            },
            success: function(data) {
                console.log('done')
                console.log(data)

                $spinner.removeClass('is-active');

                $.alert({
                    backgroundDismiss: true,
                    columnClass: 'large',
                    title: false,
                    content: confirm
                });
            },
            dataType: "json"
        });

    }

    function load($button) {
        var name = $button.data('name');
        var title = $button.text();
        var loadText = $button.data('load');
        var cancelText = $button.data('cancel');
        var deleteText = $button.data('delete');
        var deleteConfirmText = $button.data('delete-confirm');
        var noContentText = $button.data('no-content');
        var $textarea = $button.parent().parent().find("textarea");
        var userId = $button.data('user');
        var $spinner = $button.find(".acf-spinner");

        $spinner.addClass('is-active');

        $.ajax({
            type: "GET",
            url: "/wp-json/mxm_angebote/customtext/get/"+userId+"/"+name,
            success: function(data) {
                console.log('done')
                console.log(data)

                $spinner.removeClass('is-active');

                if (data === undefined || data.length == 0) {
                    $.alert(noContentText);
                } else {

                    var content = '<form action="" class="textblocks-form mt-1">';

                    $.each(data, function (i, el) {
                        content += '<div class="form-check">';
                        content += '<input class="form-check-input" type="radio" name="textblocks" id="radio' + el.id + '" value="' + el.id + '" checked>';
                        content += '<label class="form-check-label" for="radio' + el.id + '">' + el.text + '</label>';
                        content += '</div>';
                    });

                    content += '</form>';


                    $.confirm({
                        columnClass: 'large',
                        title: title,
                        content: content,
                        buttons: {
                            cancel: {
                                text: cancelText,
                                btnClass: 'mxm_button btn btn-link'
                            },
                            confirm: {
                                text: loadText,
                                btnClass: 'mxm_button btn btn-primary',
                                action: function (confirmBtn) {
                                    var checked = this.$content.find('[name="textblocks"]:checked').val();
                                    if (!checked) {
                                        $.alert(deleteConfirmText);
                                        return false;
                                    }

                                    var checkedText = this.$content.find('[name="textblocks"]:checked + label').text();
                                    $textarea.val(checkedText);
                                },
                            },
                            delete: {

                                text: deleteText,
                                btnClass: 'mxm_button btn btn-danger',
                                action: function (deleteBtn) {
                                    var checked = this.$content.find('[name="textblocks"]:checked').val();

                                    $.ajax({
                                        type: "GET",
                                        url: "/wp-json/mxm_angebote/customtext/delete/" + checked,
                                        success: function (data) {

                                            console.log('deleted')
                                            console.log(data)
                                            $.alert(deleteConfirmText);
                                        }
                                    });

                                },

                            }
                        }
                    });
                }

            },
            dataType: "json"
        });



    }
});

